import { gql } from '@apollo/client'

export const GQL_QUERY_MAIN_PAGE_CONFIG = gql`
  query MainPageConfig($id: ID,$type: String!) {
    mainPageConfig(id: $id, type: $type) {
      id
      blocks {
        type
        subtype
        order
        payload
      }
    }
  }
`
